import * as React from 'react';
import InputTitle from 'components/InputTitle';
import {Field, FieldProps} from 'formik';

/**
 * The title part of header component.
 * @param {React.TextareaHTMLAttributes<HTMLTextAreaElement>} props
 * @return {React.ReactElement}
 * @constructor
 */
export default function Title(
    props: React.TextareaHTMLAttributes<HTMLTextAreaElement>,
): React.ReactElement {
  return (
    <Field name="title">
      {({field}: FieldProps) => (
        <InputTitle
          {...props}
          {...field}
          required
        />
      )}
    </Field>
  );
}
